import RandRDashboard from './RandRDashboard';

export default RandRDashboard;
